export default "__VITE_ASSET__C83qHu4V__"